import { Routes } from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { ProfileDescriptionComponent } from "./profile-description/profile-description.component";
import { profileGuard } from "./guards/profile.guard";

export const profileRoutes: Routes = [
  { path: '', redirectTo: 'description', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'description', component: ProfileDescriptionComponent, canActivate: [profileGuard] },
]
